__turbopack_context__.v({
  "BlogInnerCont": "Blogs-module-scss-module__E7XiEW__BlogInnerCont",
  "BlogsContainer": "Blogs-module-scss-module__E7XiEW__BlogsContainer",
  "card": "Blogs-module-scss-module__E7XiEW__card",
  "cardTextDiv": "Blogs-module-scss-module__E7XiEW__cardTextDiv",
  "date": "Blogs-module-scss-module__E7XiEW__date",
  "line": "Blogs-module-scss-module__E7XiEW__line",
  "name": "Blogs-module-scss-module__E7XiEW__name",
  "searchInput": "Blogs-module-scss-module__E7XiEW__searchInput",
  "tag": "Blogs-module-scss-module__E7XiEW__tag",
});
